import React from 'react';

const Alaska = () => {
  return (
    <div>
      
    </div>
  );
}

export default Alaska;
